import { RouteConfig } from 'vue-router';

import RouterView from '@/components/appLayout/Router.vue';
import { documentAddRoute } from './documentRoute/add.route';
import { documentDetailsRoute } from './documentRoute/details.route';
import { documentListRoute } from './documentRoute/list.route';

export const documentRoute: RouteConfig = {
  path: 'document',
  component: RouterView,
  children: [documentListRoute, documentAddRoute, documentDetailsRoute]
};
